import React, { ThHTMLAttributes } from 'react';

export interface VoxelTableHeadSearchCellProps
  extends Pick<ThHTMLAttributes<HTMLTableCellElement>,
    'align' | 'onClick' | 'colSpan'
  > {
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  paddingClass?: string;
  className?: string;
  title: string;
}

export const VoxelTableHeadSearchCell: React.FC<VoxelTableHeadSearchCellProps> = ({
  children,
  onClick,
  disabled,
  align = 'left',
  colSpan,
  size = 'md',
  className,
  title,
  ...thProps
}) => {
  return (
    <th
      onClick={disabled ? () => { } : onClick}
      align={align}
      colSpan={colSpan}
      className={`
          ${size === 'lg' ? 'p-3' : ''}
          ${size === 'md' ? 'p-2' : ''}
          ${size === 'sm' ? 'p-1' : ''}
          ${className} font-sans font-medium text-gray-500`}
      {...thProps}
    >
      <span className='flex flex-row items-center gap-3 flex-nowrap'>
        {title}
        {children}
      </span>
    </th>

  );
};

export default VoxelTableHeadSearchCell;
